// STRICTNESS SLIDER — the live per-notch caption (garden-srs-redesign-spec.md §2 "The slider"
// bullet + §3 grid; garden-srs-implementation-plan.md P5 card). Pure: notch in, string out — no
// DOM reads, no state, no ajax. Also the named future source of certificate copy (P6's flower
// certificates, P7's finish-screen copy), which is why it reads i18n keys rather than owning any
// inline English of its own.
//
// One key per notch — strictness_captionN1..N10, translated in every resources_*.js.
// Each is a plain sentence saying what a word needs
// to pass at that notch: the deed, then how many times. The grid's three verdict families (spec
// §3) are what the sentences describe — A (1–3) "type it from memory after at most 2/1/1 looks at
// the answer", B (4–6) "a close-enough attempt before the answer is revealed, in 1/2/2 showings",
// C (7–10) "the exact answer before the countdown ends, in 2/3/3/3 showings" — but no caption names
// a family or quotes a number from the grid; the closeness adverb (very rough → rough → roughly
// right → close enough → almost exactly → exactly) is the honest dimmer across the notches, and
// 8–10, which share one rule, differ by emphasis only.
//
// Until 2026-09-01 the ten captions were COMPOSED (three quoted verbatim from the spec's own
// sample-tone copy, seven from a shared opening plus a per-notch tail) and spoke the spec's
// dialect — "comes back on its own, close enough" at the default notch. The owner asked what
// "comes back" meant; the metaphor (the word comes back to mind) did not survive contact with a
// reader, so the copy is now ten flat sentences in the drill's own vocabulary ("type it from
// memory", "revealed", "the countdown"), and the composition machinery went with it — a flat key
// per notch is also what lets each language phrase each notch naturally instead of agreeing a
// shared opening with seven tails. temp/check-strictness-captions.mjs asserts ten distinct,
// non-empty, non-fallback captions per locale; temp/ui-smoke/strictness-caption-width-probe.mjs
// asserts each fits the two lines the settings panel reserves (fields.css .strictnessCaptionClass).
//
// Same IIFE/global convention as closeness_v2.js / answer_diff.js: loaded via a plain <script>
// tag (main.html, before user_attr.js), the top-level "var STRICTNESS" below becomes a real
// window.STRICTNESS.
var STRICTNESS = (function () {
	"use strict";

	// notch -> showings-planned (spec §3 grid's "Showings (planned)" column: 1,1,1,1,2,2,2,3,3,3).
	// This is ALSO the fold-in value user_attr.js writes to the legacy `repetition` attr, and
	// syncs into the hidden repetition radio on every drag — see user_attr.js for the write-up
	// of why that keeps training_session.js untouched.
	var SHOWINGS_BY_NOTCH = [null, 1, 1, 1, 1, 2, 2, 2, 3, 3, 3];   // index 1..10; 0 unused

	function clampNotch(notch) {
		var n = Math.round(Number(notch));
		if (isNaN(n)) {
			return 5;   // mirrors the shipped repetition default's own notch (see user_attr.js init)
		}
		return Math.min(10, Math.max(1, n));
	}

	/** The showings-planned fold-in value (1..3) for a notch — the legacy `repetition` shape. */
	function showingsFor(notch) {
		return SHOWINGS_BY_NOTCH[clampNotch(notch)];
	}

	/** The live caption line for a notch: a non-empty, notch-distinct, localized sentence. */
	function captionFor(notch) {
		return getRes("strictness_captionN" + clampNotch(notch));
	}

	return {
		showingsFor: showingsFor,
		captionFor: captionFor
	};
})();
